module.exports = __webpack_public_path__ + "static/media/live.3b8662cc.png";